(() => {
  'use strict';

  let previousFocus = null;

  function liveParts() {
    const root = document.querySelector('[data-ckb-ai]');
    if (!root) return null;

    const parts = {
      root,
      endpoint: (root.dataset.endpoint || '').replace(/\/$/, ''),
      panel: root.querySelector('[data-ckb-ai-panel]'),
      open: root.querySelector('[data-ckb-ai-open]'),
      triggers: Array.from(document.querySelectorAll('[data-ckb-ai-open], [data-ckb-ai-inline-open]')),
      close: root.querySelector('[data-ckb-ai-close]'),
      form: root.querySelector('[data-ckb-ai-form]'),
      input: root.querySelector('[data-ckb-ai-question]'),
      submit: root.querySelector('[data-ckb-ai-submit]'),
      status: root.querySelector('[data-ckb-ai-status]'),
      messages: root.querySelector('[data-ckb-ai-messages]'),
    };

    if (
      !parts.endpoint
      || !parts.panel
      || !parts.open
      || !parts.close
      || !parts.form
      || !parts.input
      || !parts.submit
      || !parts.status
      || !parts.messages
    ) return null;

    root.dataset.ckbAiReady = 'true';
    return parts;
  }

  function setOpen(value, trigger) {
    const parts = liveParts();
    if (!parts) return;

    parts.panel.setAttribute('aria-hidden', String(!value));
    parts.triggers.forEach((item) => item.setAttribute('aria-expanded', String(value)));
    if (value) {
      previousFocus = trigger || document.activeElement;
      setTimeout(() => liveParts()?.input.focus(), 0);
    } else if (previousFocus && previousFocus.focus) {
      previousFocus.focus();
    }
  }

  function assistantPlainText(value) {
    return String(value || '')
      .replace(/\*\*([^*]+)\*\*/g, '$1')
      .replace(/__([^_]+)__/g, '$1')
      .replace(/`([^`]+)`/g, '$1');
  }

  function watchCKBHero() {
    const parts = liveParts();
    const hero = document.querySelector('[data-ckb-hero]');
    if (!parts || !hero || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(([entry]) => {
      parts.root.classList.toggle('ckb-ai--hero-visible', entry.isIntersecting);
    }, { threshold: 0.08 });

    observer.observe(hero);
  }

  function message(parts, text, type, citations) {
    const item = document.createElement('div');
    item.className = `ckb-ai__message ckb-ai__message--${type}`;
    item.textContent = type === 'assistant' ? assistantPlainText(text) : text;

    if (type === 'assistant' && Array.isArray(citations) && citations.length) {
      const list = document.createElement('ul');
      list.className = 'ckb-ai__sources';
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = parts.root.dataset.ckbUrl;
      link.textContent = 'Open the Chameleon Knowledge Base';
      li.appendChild(link);
      list.appendChild(li);
      item.appendChild(list);
    }

    parts.messages.appendChild(item);
    parts.messages.scrollTop = parts.messages.scrollHeight;
  }

  async function submit(event, target) {
    event.preventDefault();
    const parts = liveParts();
    if (!parts || target !== parts.form) return;

    const question = parts.input.value.replace(/\s+/g, ' ').trim();
    if (!question) return;

    message(parts, question, 'user');
    parts.input.value = '';
    parts.submit.disabled = true;
    parts.status.textContent = 'Checking approved sources…';
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 90000);

    try {
      const response = await fetch(`${parts.endpoint}/v1/ckb-assistant`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ question }),
        signal: controller.signal,
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.error || 'The assistant is unavailable.');
      message(parts, payload.answer || 'The approved material does not support an answer.', 'assistant', payload.citations);
      parts.status.textContent = '';
    } catch (error) {
      message(
        parts,
        error.name === 'AbortError'
          ? 'The request took too long. Please try again.'
          : error.message || 'The assistant is temporarily unavailable.',
        'assistant',
      );
      parts.status.textContent = 'Not sent';
    } finally {
      clearTimeout(timer);
      parts.submit.disabled = false;
      parts.input.focus();
    }
  }

  window.ChameleonCKBAI = {
    toggle(trigger) {
      const parts = liveParts();
      if (parts) setOpen(parts.panel.getAttribute('aria-hidden') === 'true', trigger);
    },
    close() {
      setOpen(false);
    },
    submit,
  };

  if (document.documentElement.dataset.ckbAiEscapeBound !== 'true') {
    document.documentElement.dataset.ckbAiEscapeBound = 'true';
    window.addEventListener('keydown', (event) => {
      const parts = liveParts();
      if (event.key === 'Escape' && parts?.panel.getAttribute('aria-hidden') === 'false') setOpen(false);
    });
  }

  liveParts();
  watchCKBHero();
})();
